import styled from 'styled-components'

export const ClientCard = styled.div`
    background-color: ${({ theme }) => theme.colors.container.background};
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    transition: box-shadow 0.2s ease, transform 0.15s ease;

    &:hover {
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        transform: translateY(-2px);
    }
`

export const CardTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px 10px;
`

export const ClientName = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.text};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const NegativeBadge = styled.span`
    font-size: 11px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.secondary};
    background-color: ${({ theme }) => theme.colors.secondary}18;
    border-radius: 20px;
    padding: 2px 8px;
    white-space: nowrap;
`

export const Divider = styled.div`
    height: 1px;
    background-color: rgba(0, 0, 0, 0.06);
    margin: 0 18px;
`

export const ProductList = styled.div`
    padding: 10px 18px 14px;
    display: flex;
    flex-direction: column;
    gap: 6px;
`

export const ProductRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 0;

    &:not(:last-child) {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }
`

export const ProductName = styled.span`
    font-size: 13px;
    color: ${({ theme }) => theme.text};
    opacity: 0.8;
`

export const ProductAmount = styled.span`
    font-size: 13px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.secondary};
`

export const EmptyState = styled.div`
    grid-column: 1 / -1;
    text-align: center;
    padding: 48px 24px;
    color: ${({ theme }) => theme.text};
    opacity: 0.45;
    font-size: 14px;
`

export const CardsGrid = styled.div<{ $columns: boolean }>`
    display: grid;
    grid-template-columns: ${({ $columns }) =>
        $columns ? 'repeat(auto-fill, minmax(280px, 1fr))' : '1fr'};
    gap: 12px;
`

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
`

export const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    h2 {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        color: ${({ theme }) => theme.text};
    }
`

export const ActionsRow = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        & > div {
            width: 100%;
        }
    }
`

export const ProductFilterWrapper = styled.div`
    width: 280px;
    display: flex;
    align-items: center;
    gap: 8px;

    @media (max-width: 768px) {
        width: 100%;
    }
`

export const SwitchWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-left: auto;

    @media (max-width: 768px) {
        margin-left: 0;
        width: 100%;
        justify-content: flex-end;
    }
`
